function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Button, CustomModal, TextButton, Typography } from 'seagull';
import { useOverlayContext } from 'seagull';
import { SecureLoginModal } from "../../../../SecureLoginModal/SecureLoginModal";
import { Link } from 'react-router-dom';
import { useStore, useStoreActions } from "../../../../../store/store-context";
import { useEventReporter } from "../../../../../event-reporter";
import { openInNewTabProps } from "../../../../../constants";
import { Intent } from "../../../../../infra/access-control";
import { AnchorLogo } from 'seagull/icons';
import ExternalLinkButton from "../../../../ExternalLinkButton";
import styles from "./CreateAVendorAccount.module.scss";
export const CreateAVendorAccount = _ref => {
  let {
    variant,
    onClick
  } = _ref;
  const userInfo = useStore(state => state.userInfo);
  const {
    setWorksAt
  } = useStoreActions();
  const {
    reportToHeap,
    reportToHubspot
  } = useEventReporter();
  const overlayContext = useOverlayContext();
  const VariantContent = () => {
    switch (variant) {
      case 'button':
        return /*#__PURE__*/React.createElement(Button, {
          onClick: onCreateVendorAccount,
          "data-testid": "create-a-vendor-account-btn",
          intent: Intent.ClientCreateVendorAccount
        }, "Create a Service Provider Account");
      case 'text':
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextButton, {
          className: styles.createVendorPromptText,
          underline: "none",
          onClick: onCreateVendorAccount,
          "data-testid": "create-a-vendor-account-btn",
          intent: Intent.ClientCreateVendorAccount
        }, "Sign up for a service provider account"), /*#__PURE__*/React.createElement(Typography, {
          as: "span",
          className: styles.createVendorPromptText
        }, ' ', "- it's free"));
    }
  };
  const onCreateVendorAccount = async () => {
    onClick === null || onClick === void 0 || onClick();
    reportToHubspot('create_vendor_account_clicked_v2');
    reportToHeap('top-bar', 'click', 'client-create-vendor-account-topbar');
    let hasIdentity = !!(userInfo !== null && userInfo !== void 0 && userInfo.hasIdentity());
    if (!hasIdentity) {
      hasIdentity = await overlayContext.showModal({
        closeOnClickOutside: true,
        closeOnEscapeKey: true,
        content: _ref2 => {
          let {
            dismissModal
          } = _ref2;
          return /*#__PURE__*/React.createElement(SecureLoginModal, {
            dismissModal: dismissModal
          });
        }
      });
    }
    if (hasIdentity) {
      const shouldCreateAVendorAccount = await overlayContext.showModal({
        closeOnClickOutside: true,
        closeOnEscapeKey: true,
        content: _ref3 => {
          let {
            dismissModal
          } = _ref3;
          return /*#__PURE__*/React.createElement(CreateVendorAccountConfirmationModalWithFF, {
            dismissModal: dismissModal
          });
        }
      });
      if (shouldCreateAVendorAccount) {
        await setWorksAt();
      }
    } else {
      reportToHubspot('create_vendor_account_canceled_v3');
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "create-a-vendor-account"
  }, /*#__PURE__*/React.createElement(VariantContent, null));
};
const CreateVendorAccountConfirmationModalWithFF = _ref4 => {
  let {
    dismissModal
  } = _ref4;
  const userInfo = useStore(state => state.userInfo);
  const {
    api,
    logBI
  } = useStoreActions();
  const {
    reportToHeap,
    reportToHubspot
  } = useEventReporter();
  return /*#__PURE__*/React.createElement(CustomModal, {
    title: "Create Service Provider account",
    onClose: () => {
      dismissModal(false);
      reportToHubspot('create_vendor_account_canceled_v3');
    },
    "data-testid": "create-vendor-account-confirmation",
    maxWidth: 600
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.bodyContainer
  }, /*#__PURE__*/React.createElement(AnchorLogo, {
    width: 180,
    height: 50,
    className: styles.logo
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    className: styles.title
  }, "Create a Service Provider account"), /*#__PURE__*/React.createElement(Typography, {
    className: styles.message,
    variant: "h6",
    skin: "disabled"
  }, "Anchor allows service providers to fully automate their billing, in a simple, flexible, and affordable way. Send proposals, get them signed, invoiced, paid, and fully synced to your favorite accounting software - all automatically!")), /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    as: "span",
    variant: "paragraph2",
    skin: "disabled",
    weight: "light"
  }, "By creating a Seller account, you agree to our", ' '), /*#__PURE__*/React.createElement(TextButton, _extends({
    as: Link,
    size: "small",
    skin: "secondary",
    to: {
      pathname: 'https://www.sayanchor.com/terms-of-contact'
    }
  }, openInNewTabProps, {
    underline: "none"
  }), "Terms of Service"), /*#__PURE__*/React.createElement(Typography, {
    as: "span",
    variant: "paragraph2",
    skin: "disabled",
    weight: "light"
  }, ' ', "and", ' '), /*#__PURE__*/React.createElement(TextButton, _extends({
    as: Link,
    size: "small",
    skin: "secondary",
    to: {
      pathname: 'https://www.sayanchor.com/privacy-policy'
    }
  }, openInNewTabProps, {
    underline: "none"
  }), "Privacy policy"), /*#__PURE__*/React.createElement(Typography, {
    as: "span",
    variant: "paragraph2",
    skin: "disabled",
    weight: "light"
  }, ".")), /*#__PURE__*/React.createElement("div", {
    className: styles.actions
  }, /*#__PURE__*/React.createElement(ExternalLinkButton, {
    testid: 'client-create-vendor-book-a-demo',
    openInNewTab: true,
    size: "medium",
    underline: "none",
    className: styles.demoButton,
    href: "https://meetings.hubspot.com/tal57/book-a-demo-website?utm_source=in-app&utm_medium=client_to_vendor&utm_campaign=get_a_demo_button"
  }, "Book a demo"), /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    onClick: async () => {
      logBI(18101);
      reportToHubspot('create_vendor_account_approve_v4');
      reportToHeap('top-bar', 'click', 'client-create-vendor-account-approve');
      if (!(userInfo !== null && userInfo !== void 0 && userInfo.hasApprovedTermsOfService())) {
        const userId = userInfo === null || userInfo === void 0 ? void 0 : userInfo.id();
        if (userId) {
          await api.auth.approveTos(userId);
        }
      }
      await dismissModal(true);
    },
    "data-testid": "create-vendor-account-approve-btn"
  }, "Create Service Provider account")))));
};